<template>
  <div id="tablePage">
    <!-- 订单系统流水查询 -->
    <div class="orderTable">
      <el-table
        ref="tableData"
        :data="tableData"
        :height="tableHeight"
        v-loading="loading"
      >
        <template slot="empty" v-if="!loading">
          <div v-if="isNetWrong" class="no-datas">
            <div class="no-data-img">
              <img src="../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data" style="margin-top: -15px !important; text-align: center;" @click="showData">加载失败,点击重试</div>
          </div>
          <div v-else class="no-datas">
            <div class="no-data-img">
              <img src="../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data">暂无数据</div>
          </div>
        </template>
        <el-table-column
          prop="flowId"
          label="流水号"
        >
        </el-table-column>
        <el-table-column
          prop="bizName"
          label="类型"
        >
        <!-- <template slot-scope="scope">
            {{ scope.row.bizCode | dateFormate }}
          </template> -->
        </el-table-column>
        <el-table-column
          prop="amount"
          label="发生额"
        >
        <template slot-scope="scope">
          <span :style="{color: scope.row.amountColor}">{{ scope.row.amount }}</span>
        </template>
        </el-table-column>
        <el-table-column
          prop="balance"
          label="资金余额"
        >
        </el-table-column>
        <el-table-column
          prop="occurTime"
          label="发生时间"
          width="90"
        >
          <template slot-scope="scope">
            {{ scope.row.occurTime | dateFormate }}
          </template>
        </el-table-column>
      </el-table>
      <el-row v-if="pageData.total">
        <el-col :span="24" class="paginateWrap">
          <el-pagination
            popper-class="_popStyle"
            :current-page="pageData.currentPage"
            :page-sizes="pageData.pageSizes"
            :page-size="pageData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
/*global http protocol util*/
import { mapGetters } from 'vuex'
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['time', 'isSearch', 'marketId'],
  data() {
    return {
      tableHeight: 0,
      loading: false,
      checked: false,
      tableData: [],
      pageData: {
        total: null,
        pageSizes: [10, 20, 30, 40],
        pageSize: 20,
        currentPage: 1
      },
      // 表格label宽度
      tcdTableWidth: {
        bsFlag: 80,
        ocFlag: 110,
        closePl: 100
      },
      TradeListSum: {
        'bsFlag': '',
        'closePl': 0,
        'commodityCode': '',
        'commodityId': 0,
        'commodityName': '',
        'createTime': 0,
        'fee': 0,
        'firmId': 0,
        'holdDetailId': 0,
        'margin': 0,
        'ocFlag': '',
        'orderId': 0,
        'quantity': 0,
        'singlePrice': 0,
        'tqTip': 0,
        'tradeDay': 0,
        'tradeId': 0,
        'tradeType': 0,
        'updateTime': 0,
        'stampFee': 0
      },
      isNetWrong: false,
      beginTime: [util.formatnewDay(Number(new Date())), util.formatnewDay(Number(new Date()))]
    }
  },
  computed: {
    ...mapGetters(['sessionInfoGetter', 'commodityParamListGetter', 'commodityStrategyGetter'])
  },
  watch: {
    isSearch(val) {
      if (val) {
        this.pageData.currentPage = 1
        this.showData()
      }
    }
  },
  created() {
    window.onresize = () => {
      this.$nextTick(() => {
        this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      })
    }
  },
  updated() {
    this.$nextTick(() => {
      this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      this.$refs['tableData'].doLayout()
    })
  },
  mounted() {
    this.showData()
  },
  methods: {
    // 分页
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.showData()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.showData()
    },
    loadData() {
      this.pageData.currentPage = 1
      this.pageData.pageSize = 20
      this.showData()
    },
    // 订单展示
    showData() {
      const that = this
      this.loading = true
      let currentProtol = protocol.queryFirmAccountFundsFlow
      if (this.time[0] != this.beginTime[0] || this.time[1] != this.beginTime[1]) {
        currentProtol = protocol.queryFirmAccountFundsFlowH
        currentProtol.param.startTradeDay = this.time[0]
        currentProtol.param.endTradeDay = this.time[1]
        currentProtol.param.symbolId = 1
        currentProtol.param.marketId = this.marketId
      }
      currentProtol.param.page = this.pageData.currentPage - 1
      currentProtol.param.size = this.pageData.pageSize
      currentProtol.param.sort = [
        {
          direction: 'DESC', // "//DESC或ASC",
          property: 'flowId' // "//排序属性"
        }
      ]
      http.postFrontChange(currentProtol, this.marketId).then(response => {
        if (response.data.code != 0) {
          this.$message({ message: response.data.message })
          this.isNetWrong = true
        } else {
          this.isNetWrong = false
        }
        if (response.data) {
          if (response.data && response.data.code == '0') {
            this.pageData.total = response.data.value.totalElements
            const arr = response.data.value.content
            arr.forEach(element => {
              element.amountColor = Number(element.amount) > 0 ? '#D9001B' : '#41B37D'
              element.amount = util.formatNum(element.amount)
              element.balance = util.formatNum(element.balance)
            })
            this.tableData = arr
            // this.TradeListSum = response.data.value.sumData
          }
        }
        this.loading = false
      }).catch((e) => {
        this.loading = false
        setTimeout(() => {
          that.showData()
        }, 1000)
      })

      // protocol.queryTradeListSum.data = protocol.queryUserClinches.data
      // http.gPost(protocol.queryTradeListSum).then(response => {
      //   if (response.data.code != 0) {
      //     this.$message({ message: response.data.message })
      //   }
      //   if (response.data) {
      //     if (response.data && response.data.code == '0') {
      //       this.TradeListSum = response.data.value
      //     }
      //   }
      // })
    },
    // 合计
    getSummaries(param) {
      const { columns } = param
      const sums = []
      const that = this
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (index === 3) {
          sums[index] = '共' + this.pageData.total + '条'
          return
        }
        if (index === 7) { // 成交数量
          sums[index] = that.TradeListSum.quantity
          return
        }
        if (index === 8) { // 成交金额
          sums[index] = that.TradeListSum.funds
          return
        }
        // if (index === 10) { // 转让存货价
        //   sums[index] = that.TradeListSum.fee
        //   return
        // }
        if (index === 10) { // 利润
          sums[index] = that.TradeListSum.closePl
          return
        }
        if (index === 11) { // 印花税
          sums[index] = that.TradeListSum.stampFee
          return
        }
        if (index === 12) { // 手续费
          sums[index] = that.TradeListSum.fee
          return
        }
        sums[index] = ''
      })
      return sums
    },
    // 根据语言改变样式
    setLanguageCss() {
      // 防止清缓存后数据消失
      this.$i18n.locale = localStorage.lang || navigator.language.slice(-2).toLowerCase()
      switch (localStorage.lang) {
        case 'en': {
          const tcdTableEnWidth = {
            bsFlag: 120,
            ocFlag: 150,
            closePl: 150
          }
          localStorage.setItem('tcdTableEnWidth', JSON.stringify(tcdTableEnWidth))
          this.tcdTableWidth = JSON.parse(localStorage.tcdTableEnWidth)
        }
          break
        default:
          break
      }
    }

  }

}
</script>
